module.exports = __webpack_public_path__ + "media/nav/item_completed_task-cc224a11.png";